export default __webpack_public_path__ + "static/media/multiplication.631b842f.svg";